var map = {
	"./aliyu.png": "4d72",
	"./anthony.png": "e864",
	"./assumpta.png": "71a9",
	"./augustus.png": "18ec",
	"./brajesh.png": "16bc",
	"./chibueze.png": "d02d",
	"./chibuike.png": "6765",
	"./chidiebere.png": "39d3",
	"./chidimma.png": "522a",
	"./chinedu.png": "aab8",
	"./chinonso.png": "f813",
	"./chuka.png": "1e00",
	"./collins.png": "282e",
	"./daberechi.png": "d139",
	"./darlynton.png": "aac7",
	"./dominic.png": "d31e",
	"./emmanuel.png": "7011",
	"./ethothy.png": "fa05",
	"./faisal.png": "45fe",
	"./frank.png": "9174",
	"./godwin.png": "8a60",
	"./hussaini.png": "9ede",
	"./ifeanyi.png": "b074",
	"./ikem.png": "3dee",
	"./ilowa.png": "a5ac",
	"./julius.png": "c073",
	"./kelvin.png": "c56e",
	"./lawrence.png": "1c77",
	"./mako.png": "2647",
	"./mary.png": "dbca",
	"./michael.png": "ffab",
	"./ndibe.png": "2535",
	"./ngozi.png": "5045",
	"./njideka.png": "099f",
	"./nkechi.png": "ca24",
	"./omen.png": "0add",
	"./onuorah.png": "aef9",
	"./rajneesh.png": "fd91",
	"./rapheal.png": "eb41",
	"./rita.png": "af73",
	"./stephen.png": "b876",
	"./tita.png": "fb48"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "50cd";